import {
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Divider
} from "@mui/material";

export const Sidebar = ({
  selectedContainer,
  onSelectContainer,

  // search props
  searchActive,
  searchValue,
  onSearchChange,
  onSearchOpen,
  onSearchClose,
  onSearchKeyDown,
}) => {
  const items = [{ key: "dev", label: "App Development" }];

  return (
    <div className="w-full border-b shadow-sm p-3 bg-gradient-to-r from-slate-50 via-white to-indigo-50">
      <Box className="flex items-center justify-between gap-3 flex-wrap">
        {/* Left: title + search */}
        <Box className="flex items-center gap-3 flex-wrap">
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            App Development
          </Typography>

          {!searchActive ? (
            <Button
              variant="outlined"
              size="small"
              onClick={onSearchOpen}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                bgcolor: "rgba(255,255,255,0.85)",
              }}
            >
              Search… (Ctrl/⌘K)
            </Button>
          ) : (
            <TextField
              autoFocus
              size="small"
              placeholder="Search… (Ctrl/⌘K)"
              value={searchValue || ""}
              onChange={onSearchChange}
              onKeyDown={onSearchKeyDown}
              sx={{
                width: 260,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  bgcolor: "rgba(255,255,255,0.85)",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={onSearchClose}
                      aria-label="Close search"
                    >
                      ✕
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Box>

        {/* Right: app scope */}
        <Box className="flex items-center gap-2 flex-wrap">
          <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
            Containers
          </Typography>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          <List
            sx={{
              display: "flex",
              flexDirection: "row",
              p: 0,
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            {items.map((item) => {
              const active = selectedContainer === item.key;

              return (
                <ListItemButton
                  key={item.key}
                  selected={active}
                  onClick={() => onSelectContainer(item.key)}
                  sx={{
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: active
                      ? "1px solid rgba(99,102,241,0.35)"
                      : "1px solid rgba(0,0,0,0.06)",
                    borderLeft: active
                      ? "3px solid rgba(99,102,241,0.95)"
                      : "3px solid transparent",
                    bgcolor: active
                      ? "rgba(99,102,241,0.12)"
                      : "rgba(255,255,255,0.75)",
                    "&:hover": {
                      bgcolor: active
                        ? "rgba(99,102,241,0.16)"
                        : "rgba(0,0,0,0.04)",
                    },
                    transition:
                      "background-color 150ms ease, border-color 150ms ease",
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: active ? 700 : 500,
                        fontSize: 13,
                        whiteSpace: "nowrap",
                      },
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      </Box>
    </div>
  );
};